import styled from 'styled-components';
import { getSizeBy } from '../../../src/styled/utils';
export const StyledListItemIcon = styled.span `
  display: inline-flex;
  flex-shrink: 0;
  margin-right: ${getSizeBy(2.5)};
`;
